var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cust_uploader" },
    [
      _c("input", {
        ref: "fileInput",
        attrs: { type: "file", accept: _vm.accept, multiple: _vm.multiple },
        on: { change: _vm.onFileChange }
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "white" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            right: "",
                            absolute: "",
                            fab: "",
                            color: "primary",
                            small: ""
                          },
                          on: { click: _vm.activateFilePrompt }
                        },
                        [_c("v-icon", [_vm._v("add")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-toolbar-title",
                        [
                          _c("v-icon", [_vm._v("attach_file")]),
                          _vm._v(" " + _vm._s(_vm.label) + "\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    _vm._l(_vm.files, function(item, index) {
                      return _c(
                        "v-list-tile",
                        { key: item.name, on: { click: function($event) {} } },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("insert_drive_file")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", {
                                domProps: { textContent: _vm._s(item.name) }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-action",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.deleteAttachment(index)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("delete_forever")])],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5268b5d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5268b5d0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vuetify-upload-component/Vuetify_upload_component.vue
// module id = null
// module chunks = 